import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { noop } from 'utils/noop';

// type Props = {
//   /** Header of the delete modal. */
//   header: string,
//   /** Function to close delete modal. */
//   onClose: () => void,
//   /** Function to delete selected catalog collection. */
//   onDelete: (selectedCollection: {}) => void,
//   /** The selected collection to delete. */
//   selectedCollection: {},
// };

export const DELETE_COLLECTION_MODAL_TEST_ID = 'delete-collection-modal';
export const DELETE_BUTTON_TEST_ID = 'delete-collection-modal-delete-button';

export const DeleteCollectionModal = ({
  header = 'Delete collection?',
  onClose = noop,
  onDelete = noop,
  selectedCollection = {},
}) => {
  return (
    <Modal
      data-test={DELETE_COLLECTION_MODAL_TEST_ID}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>{header}</ModalHeader>
      <ModalBody>
        Are you sure you want to delete <strong>{selectedCollection.name}</strong>? This cannot be
        undone.
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          size={BUTTON_SIZES.LARGE}
          data-test={DELETE_BUTTON_TEST_ID}
          onClick={() => onDelete(selectedCollection)}
        >
          Delete collection
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
